export const INIT_ERROR = 'INIT_ERROR'

export const SAVE_STORE_TABLE_INFO = 'save_store_table_info'

export const FETCH_STORE_REQUEST = 'fetch_store_request'
export const FETCH_STORE_RESPONSE = 'fetch_store_response'
